import React, {createRef, useEffect, useState } from 'react'
import AxiosAuth from '../../utility/AxiosAuth';
import ConfigApi from '../../utility/ConfigApi';
import InitInfo from '../../utility/InitInfo';
import { useTemplate } from '../../context/TemplateProvider';
import { useModal } from '../../context/ModalContext';
import { handleFormSubmit } from '../../utility/formHelpers';
import axios from 'axios';

const CustomerModal=({onSubmit,data,uploadRef,userId,setMessage})=>{
  const [imageInfo, setImageInfo] = useState({image_url:data?.image_url,image_id:data?.image_id});

  const handleOnFileChange = async ({ target }) => {
    const { files } = target;
    
    for (let x = 0; x < files.length; x += 1) {
        const formData = new FormData();
        formData.append('userId', userId);
        formData.append('image', files[x]);
        const formValues = {};
        formData.forEach((value, key) => {
          formValues[key] = value;
        });          
        const response = await axios.post(ConfigApi.IMAGE_UPLOAD.replace(':userSl', userId), formValues, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        
        if (response.data?.error===0) {                        
          setImageInfo(response.data);
         
        }else{
          setMessage({type: 'error', text: response?.data?.message})
        }
    }
  };
  
  return (
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
      <form onSubmit={onSubmit} className="space-y-6">    
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
          Investor Name
          </label>
          <input
              type="hidden"
              name="id"
              defaultValue={data?.sl}
          />
          <div className="mt-2">
            <input
              type="text"
              name="name"
              defaultValue={data?.name}
              placeholder="Type Investor Name"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
            Email address
          </label>
          <div className="mt-2">
            <input
              type="email"
              name="email"
              defaultValue={data?.email}
              placeholder="Type Email Address"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Contact Number
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="contact"
              defaultValue={data?.contact}
              placeholder="Type Contact Number"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Address
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="address"
              defaultValue={data?.address}
              placeholder="Type Address"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Join Date
          </label>
          <div className="mt-2">
            <input
              type="date"
              name="join_date"
              defaultValue={data?.joinDate}
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        {data?.sl?(<div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Status
          </label>
          <div className="mt-2">
            <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="status">
                <option>Select Status</option>
                <option value="active" selected={data?.status==='active'?true:false}>Active</option>
                <option value="inactive" selected={data?.status==='inactive'?true:false}>In Active</option>
            </select>
          </div>
        </div>):""}
        <div>
          <button className='flex justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600' type='button' onClick={() => {
              uploadRef.current.click();
          }}>Upload Image</button>
          <input
                ref={uploadRef}
                type="file"
                name="file"
                onChange={handleOnFileChange}
                multiple
                style={{ display: 'none' }}
                accept="image/png, image/jpeg"
          />
          <input
                type="text"
                name="image_url"
                style={{ display: 'none' }}
                value={imageInfo?.image_url??""}
          />
          <input
                type="text"
                name="image_id"
                style={{ display: 'none' }}
                value={imageInfo?.image_id??""}
          />
          {imageInfo?.image_url ?
          <img src={imageInfo?.image_url} className='mt-3'/>
          :""}
        </div>
        <div>
          <button type="submit"
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {data?.sl?"Update":"Create New" }
          </button>
        </div>
      </form>
    </div>
    )
  }

  
function InvestorList() {
    const {userId} = InitInfo();
    const [isLoading, setIsLoading] = useState(false)
    const uploadRef = createRef();

    const [customerData, setCustomerData] = useState()
    const [error, setError] = useState(null)
    const {setMessage,setLoading,setHeaderText,reloadKey,setReloadKey}=useTemplate()
    const [filteredCustomerData, setFilteredCustomerData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const {setModalTitle, openModal,closeModal } = useModal();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(123)
        try {
          const data = await handleFormSubmit(ConfigApi.INVESTOR_CREATE, event.currentTarget, setIsLoading, setError);
          setLoading();
          console.log(data);
          
          if (data?.error===0) {            
            closeModal()
            setReloadKey(data.reloadKey)
  
            setMessage({type: 'success', text: data?.message})
          }else{
            setMessage({type: 'error', text: data?.message})
          }
        } catch (error) {
        }
    };
    const handleUpdateSubmit = async (event) => {
        event.preventDefault();
        setLoading(123)
        try {
          const data = await handleFormSubmit(ConfigApi.INVESTOR_UPDATE, event.currentTarget, setIsLoading, setError);
          setLoading();
          if (data?.error===0) {
            closeModal()
            setReloadKey(data.reloadKey)
  
            setMessage({type: 'success', text: data?.message})
          }else{
            setMessage({type: 'error', text: data?.message})
          }
        } catch (error) {
        }
      };
  
    const handleOpenModal = () => {
        openModal(<CustomerModal onSubmit={handleSubmit} data={{}} uploadRef={uploadRef} userId={userId} setMessage={setMessage}/>);
        setModalTitle("Create New Investor")
      };
      
    const handleOpenEditModal=(e)=>{
        openModal(<CustomerModal onSubmit={handleUpdateSubmit} data={e} uploadRef={uploadRef} userId={userId} setMessage={setMessage}/>);
        setModalTitle("Update Investor")
    }

    useEffect(()=>{
        setHeaderText('Investor List')
        if (userId) {
          setLoading(123);
          AxiosAuth.post(ConfigApi.INVESTOR_LIST, {userId})
            .then(({data}) => {
              setLoading();
  
              if (data.error===0) {
                setCustomerData(data.data);
              }else{
                setMessage({type: 'error', text: data.message})
              }
              
            })
            .catch(err => {
              console.log(err);
            });
        }
      },[userId,reloadKey])

      useEffect(() => {
        if (searchTerm) {
          const filteredData = customerData.filter((customer) =>
            customer.name.toLowerCase().includes(searchTerm.toLowerCase())
          );
          setFilteredCustomerData(filteredData);
        } else {
          setFilteredCustomerData(customerData);
        }
      }, [searchTerm, customerData]);  
      let Sl=1;


  return (
    <div>
        <div className="relative overflow-x-auto sm:rounded-lg">
            <div className="pb-4 bg-white dark:bg-gray-900">
                <label htmlFor="table-search" className="sr-only">Search</label>
                <div className="flex items-center justify-between mt-1">
                    {/* Search Bar */}
                    <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg
                                className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                />
                            </svg>
                        </div>
                        <input
                            type="text"
                            id="table-search"
                            className="block pt-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search for items"
                        />
                    </div>

                    {/* Add New Member Button */}
                    <button
                    
                        onClick={handleOpenModal}
                        type="button"
                        className="px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-blue-600"
                    >
                        Add New Investor
                    </button>
                </div>

            </div>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="p-4">
                            SL
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Name
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Contact
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Email
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Join Date
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Balance
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Address
                        </th>
                        
                        <th scope="col" className="px-6 py-3">
                            Image
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Status
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {customerData && filteredCustomerData?.map((row)=>(
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={row.sl}>
                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{Sl++}</td>
                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {row.name}
                        </th>
                        <td className="px-6 py-4">
                            {row.contact}
                        </td>
                        <td className="px-6 py-4">
                            {row.email}
                        </td>
                        <td className="px-6 py-4">
                            {row.joinDate}
                        </td>
                        <td className="px-6 py-4">
                            {row?.balance}
                        </td><td className="px-6 py-4">
                            {row.address}
                        </td>
                        <td className="px-6 py-4">
                          {row?.image_url ?
                            <img src={row?.image_url} className='w-[100px] mt-3'/>
                          :""}
                        </td>
                        <td className="px-6 py-4">
                            {row.status}
                        </td>
                        <td className="px-6 py-4 text-center">
                            <button type="button"  onClick={()=>handleOpenEditModal(row)}>Edit</button>
                            
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default InvestorList